import { FAQ, UNIT, SEGMENTATIONS } from '../../utils/constants';
import { contractIsActive } from '../../utils';
import enums from '../../utils/enums';
import requestService from '../../services/request';
export default {
  state: {
    faqs: [],
    requestId: null,
    loading: false,
    error: null,
  },
  getters: {
    [FAQ.GET_FAQS]: (state) => state.faqs,
    [FAQ.GET_FAQS_LOADING]: (state) => state.loading,
    [FAQ.GET_FAQS_ERROR]: (state) => !!state.error,
  },
  mutations: {
    [FAQ.SET_FAQS]: (state, payload) => {
      state.faqs = payload;
    },
  },
  actions: {
    [FAQ.FETCH_FAQS]: async ({ state, getters, commit, dispatch }) => {
      if (state.loading) return;
      try {
        state.error = null;
        state.loading = state.faqs.length === 0;

        const limit = 0; //? get all the faqs
        const url = `${process.env.CRUD_API_GET}/faq`;

        const unitContract =
          getters[UNIT.GET_SELECTED].contracts.find(contractIsActive);
        await dispatch(UNIT.FETCH_PRODUCT);

        let segmentations = await getters[UNIT.GET_SEGMENTATIONS];
        //? Create an unique Id to cache the requests
        const requestId = segmentations.reduce(
          (prev, curr) => `${prev};${curr}`,
          `${unitContract.id}`
        );
        if (state.requestId === requestId) {
          return;
        }
        state.requestId = requestId;

        const promises = [
          requestService(url, 'GET', {
            params: { filter: { active: true, segmentations }, limit },
            localErrorHandling: true,
          }),
          requestService(`${process.env.CRUD_API_GET}/faqOrder`, 'GET', {
            localErrorHandling: true,
          }),
        ];
        const [faqs, orderResult] = await Promise.all(promises);

        //? Use the ordenation set on Admin view
        const faqOrder =
          orderResult.items[0] && orderResult.items[0].order
            ? orderResult.items[0].order
            : [];
        if (faqOrder.length > 0) {
          const faqObjects = {};
          faqOrder.forEach((faqId) => {
            if (faqId)
              faqObjects[faqId] = faqs.items.find((faq) => faq._id === faqId);
          });
          faqs.items = faqOrder
            .filter((faqId) => faqObjects[faqId])
            .map((id) => faqObjects[id]);
        }
        commit(FAQ.SET_FAQS, faqs.items);
      } catch (error) {
        console.error(error);
      } finally {
        state.loading = false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/faqs.js